import axios from './axios'
import { Link } from '@/../../EshJSLib/models/patient'
import * as model from '@/../../EshJSLib/models/patient';


export async function saveLink(params: Link) {
    let  response ={} as any;
    const json = JSON.stringify(params);
        response =  await axios.post(`/api/linkPersonale`, json).catch((error) => {
        throw error
        })
     return response;
}

export async function getLinkPersonale(idp: Number) {
    const response = await axios.get(`/api/getLinkPersonale/${idp}`);
    return response.data.data as Link[];
}


export async function deleteLink(id: Number) {
    const response = await axios.delete(`/api/linkPersonale/${id}`);
    return response.data;
}